{
  "title": "My Profile",
  "subtitle": "View your account details and manage your password.",
  "sections": {
    "details": "Account Details",
    "changePassword": "Change Password"
  },
  "fields": {
    "username": "Username",
    "email": "Email",
    "company": "Company",
    "branch": "Branch",
    "department": "Department",
    "roles": "Roles",
    "lastLogin": "Last Login"
  },
  "notAvailable": "—",
  "photo": {
    "takePhoto": "Take Photo",
    "uploadPhoto": "Upload Photo"
  },
  "changePasswordForm": {
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm New Password",
    "submit": "Update Password",
    "validation": {
      "currentPasswordRequired": "Current password is required.",
      "newPasswordMinLength": "New password must be at least 8 characters.",
      "confirmPasswordMismatch": "Passwords do not match."
    }
  }
}
